<template>
    <div class="blog-edit-wrapper">
        <div class="row">
            <div class="col-lg-6">
                <div class="card  blog-edit-wrapper" >
                    <div class="card-body">
                        <h3>Create an Authorization Code</h3>
                        <!-- Form -->
                        <form action="javascript:;" class="mt-2" v-on:submit.prevent="publishVideo">
                            <div class="row">
            
                                <div class="col-md-12 col-12">
                                    <div class="form-group mb-2">
                                        <label for="response_type">Market Place</label>
                                        <b-form-input
                                            id="response_type"
                                            v-model="market_place"
                                            placeholder="Response Type"
                                        />
                                    </div>
                                </div>
            
                                <div class="col-md-6 col-12">
                                    <div class="form-group mb-2">
                                        <label for="response_type">Response Type</label>
                                        <b-form-input
                                            id="response_type"
                                            v-model="response_type"
                                            placeholder="Response Type"
                                        />
                                    </div>
                                </div>
            
                                <div class="col-md-6 col-12">
                                    <div class="form-group mb-2">
                                    <label for="redirect_url">Callback Url</label>
                                    <b-form-input
                                        id="redirect_url"
                                        v-model="redirect_url"
                                        placeholder="Callback Url"
                                    />
                                    </div>
                                </div>
                                <div class="col-md-12 col-12">
                                    <div class="form-group mb-2">
                                        <label for="client_id">Client Id</label>
                                        <b-form-input
                                        id="client_id"
                                        v-model="client_id"
                                        placeholder="Client Id"
                                        />
                                    </div>
                                    </div>
                                <div class="form-group mb-2 col-lg-12 col-sm-12">
                                    <label for="api_codes">Scope</label>
                                    <v-select
                                        id="blog-edit-category"
                                        v-model="scopes"
                                        multiple
                                        placeholder="Scope"
                                        :options="scopes_lists"
                                    />
                                </div>
                                <div class="col-12 mt-50">
                                    <button id="generate-url-code" type="button" class="btn btn-primary mr-1"  v-on:click="generateUrlCode()">Get GoHighLevel Code</button>
                                </div>
                            </div>
                        </form>
                        <!--/ Form -->
                    </div>
                </div>
            </div>
            <generate-gohighlevel-access-token/>
        </div>
    </div>
    </template>
    <script>
    import { ref } from 'vue'
    import vSelect from 'vue-select'
    import {BFormInput,BFormTextarea} from 'bootstrap-vue-3'
    import 'vue-advanced-cropper/dist/style.css';
    import 'vue-select/dist/vue-select.css';
    import { useVuelidate } from '@vuelidate/core'
    import { required } from '@vuelidate/validators'
    import { useSettingStore } from '../../stores/SettingStore.js'
    export default{
        components:{
            vSelect,
        },
        data(){
            return {
                market_place : "https://marketplace.gohighlevel.com/oauth/chooselocation?",
                response_type :'code',
                redirect_url : ref(null),
                client_id:ref(null),
                scopes:ref([]),
                settingStore: useSettingStore(),
                vuelidate: useVuelidate(),
                scopes_lists:['contacts.write', 'contacts.readonly', 'users.readonly', 'users.write', 'locations/tags.readonly','locations/tags.write']
            }
        },
        watch:{
            'settingStore.gohighlevel_clients'(value) {
                this.client_id = value.client_id
            }
        },
        mounted(){
            this.settingStore.fetchSetting();
            var host = window.location.protocol + "//" + window.location.host;
            this.redirect_url = host;
        },
        
        validations () {
            return {
                redirect_url : {
                    required,
                },
                client_id : {
                    required,
                },
                scopes : {
                    required,
                },
            }
        },
        methods:{
            generateUrlCode(){
                
                this.vuelidate.$validate();
                if(this.vuelidate.$errors.length <= 0){
                    let scope = this.generateScopes(this.scopes);
                    let url = `${this.market_place}response_type=${this.response_type}&redirect_uri=${this.redirect_url}&client_id=${this.client_id}&scope=${scope}`;
                    window.open(url, '_blank');
                }else{
                    toastr.error('Please check your required field and try again','Gohighlevel Code')
                }
                
            },
            generateScopes(scopes){
                let scopes_to_text = scopes.toString();
                let scope_text = scopes_to_text.replaceAll(',', ' ');
                return scope_text;
            }
        }
    }
    </script>